import React from 'react';
import { injectIntl } from 'react-intl';

export class SearchBox extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            searchButtonEnabled: false
        };
        if (!this.props.handleSearch || typeof(this.props.handleSearch) != 'function') {
            throw "Search box needs a handleSearch function prop";
        }

        this.initialValue = this.props.initialValue;

        this.searchClickHandler = this.searchClickHandler.bind(this);
        this.inputChange = this.inputChange.bind(this);
        this.keyPress = this.keyPress.bind(this);
    }

    componentDidMount() {
        if (this.initialValue) {
            this.refs.searchText.value = this.initialValue;
            this.initialValue = null;
        }
    }

    componentWillUpdate(nextProps) {
        if (this.props.initialValue == nextProps.initialValue) return;
        if (nextProps.initialValue) {
            this.refs.searchText.value = nextProps.initialValue;
        } else {
            this.refs.searchText.value = '';
        }
    }

    getPreparedSearchTextValue() {
        let searchText =  this.refs.searchText.value;
        searchText = searchText.trim();
        return searchText;
    }

    searchClickHandler() {
        this.props.handleSearch(this.getPreparedSearchTextValue());
    }

    keyPress(event) {
        if(event.key == "Enter" && this.state.searchButtonEnabled){
            this.props.handleSearch(this.getPreparedSearchTextValue());
        }
    }

    inputChange() {
        if (this.refs.searchText.value.trim() == "") {
            if (this.state.searchButtonEnabled) {
                this.setState({searchButtonEnabled:false})
            }
        } else {
            if (!this.state.searchButtonEnabled) {
                this.setState({searchButtonEnabled:true})
            }
        }
    }

    render() {
        return (
            <span className="search_box">

                    <input className="notranslate"
                           type="text" ref="searchText"
                           name="search"
                           placeholder={this.props.intl.formatMessage({id: 'General_CoreFunctionality_UIText_general.search'})}
                           onChange={this.inputChange}
                           onKeyPress={this.keyPress}/>
                    {
                        this.state.searchButtonEnabled ? (<button type="button" className="search-icon la-Search" onClick={this.searchClickHandler} ></button>)
                                                       : (<button type="button" disabled className="search-icon la-Search"></button>)
                    }
            </span>
        );
    }
}

// Wraps the component in order to provide intl prop to it. We use this in order
// to access the Intl API so that we can use messages without placeholders.

export default injectIntl(SearchBox);


// WEBPACK FOOTER //
// ./src/scripts/reusable/SearchBox/SearchBox.index.jsx